import React, { MutableRefObject } from "react";
import { Flex } from "theme-ui";
import { KeenSliderInstance, KeenSliderHooks } from "keen-slider";
interface Props {
  instanceRef: MutableRefObject<KeenSliderInstance<
    {},
    {},
    KeenSliderHooks
  > | null>;
  currentSlide: number;
}

const SliderNavigation = ({ instanceRef, currentSlide }: Props) => {
  return (
    <Flex
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        alignSelf: "center",
        width: 230,
      }}
    >
      <div
        onClick={(e: any) => e.stopPropagation() || instanceRef.current?.prev()}
        sx={{
          zIndex: 3,
          display: ["block"],
          cursor: "pointer",
        }}
      >
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="black"
        >
          <path d="M32 14L19 27L32 40" strokeWidth="3" />
          <circle
            cx="27"
            cy="27"
            r="26"
            transform="rotate(-180 27 27)"
            strokeWidth="2"
          />
        </svg>
      </div>
      <div
        className="dots"
        sx={{
          justifyContent: "center",
          display: ["flex", null, null, "none"],
          ".dot": {
            height: 12,
            width: 12,
            borderRadius: "50%",
            bg: "brand.neutral",
            mx: 2,
          },
          ".active": {
            bg: "brand.darkBlue",
          },
        }}
      >
        {[
          ...Array(instanceRef.current?.track.details.slides.length).keys(),
        ].map((idx) => {
          return (
            <button
              key={idx}
              onClick={() => {
                instanceRef.current?.moveToIdx(idx);
              }}
              className={"dot" + (currentSlide === idx ? " active" : "")}
            ></button>
          );
        })}
      </div>
      <div
        onClick={(e: any) => e.stopPropagation() || instanceRef.current?.next()}
        sx={{
          zIndex: 3,
          display: ["block"],
          cursor: "pointer",
        }}
      >
        <svg
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="black"
        >
          <path d="M22 40L35 27L22 14" strokeWidth="3" />
          <circle cx="27" cy="27" r="26" strokeWidth="2" />
        </svg>
      </div>
    </Flex>
  );
};

export default SliderNavigation;
